import React from "react";
import { Card, Badge } from "react-bootstrap";
import "../../assets/css/icons.css";
import CustomDropdown from "./CustomDropdown";
import { withNamespaces } from "react-i18next";

const NextTask = ({ apagarWidget, ...props }) => {
  const { t } = props;
  return (
    <div className="main-card-v2">
      <Card bsPrefix="card-flat">
        <Card.Header className="justify-content-between">
          <h6>
            <i className="icon-tarefas2 mr-2" /> {t("NextTask.title")}
          </h6>
          <CustomDropdown apagarWidget={apagarWidget} />
        </Card.Header>
        <Card.Body>
          <div className="d-flex">
            <div className="flex-grow-1">
              <h5 className="font-weight-bold">IVA</h5>
            </div>
            <div>
              <a>
                <i className="icon-attach"></i>
              </a>
              <button type="button" className="btn btn-generic btn-sm">
                <i className="icon-check mr-2"></i> Completar Tarefa
              </button>
            </div>
          </div>
          <hr />
          <div>
            <p style={{ margin: "0px" }}>
              <b>Prazo:</b> 15 outubro (faltam ? dias)
              <i className="icon-circle small c-urgent"></i>
            </p>
            <p style={{ margin: "0px" }}>
              <b>Coima:</b> 65.000€ em caso de dolo, 45.000€ em caso de
              negligência
            </p>
            <p style={{ margin: "0px" }}>
              <b>Caráter:</b> Trimestral
            </p>
          </div>
          <div className="float-right">
            <div className="row">
              <h4>
                {" "}
                Estado: <Badge variant="warning">Urgente</Badge>
              </h4>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};
export default withNamespaces()(NextTask);
